import React from "react";
import PropTypes from "prop-types";
import { Grid, GridItem } from "@domestika-dev/prudencio/dist/atoms/Layout";
import { Form } from "@domestika-dev/prudencio/dist/atoms/Form";

export const SharedVisibility = ({ label, checked, onChange, ...rest }) => {
  return (
    <Grid {...rest}>
      <GridItem>
        <Form.Checkbox
          size="small"
          id="sharedVisibility"
          name="sharedVisibility"
          label={label}
          checked={checked}
          value="sharedVisibility"
          onChange={isChecked => onChange({ sharedVisibility: isChecked })}
        />
      </GridItem>
    </Grid>
  );
};

SharedVisibility.propTypes = {
  label: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
};

SharedVisibility.defaultProps = {
  label: "",
  checked: false,
  onChange: () => {},
};

export default SharedVisibility;
